// Función de devolución de llamada para el Intersection Observer
const callback = (entries, observer) => {
  entries.forEach(entry => {
    const section = entry.target;
    const layers = section.querySelectorAll('.parallax-layerD');
    const layersI = section.querySelectorAll('.parallax-layerI');
    const layersT = section.querySelectorAll('.parallax-layerT');
    const hojasD = section.querySelectorAll('.hojader');
    const hojasI = section.querySelectorAll('.hojaizq');

    if (entry.intersectionRatio >= 0.5) {
      //Frutas movimiento derecha
      layers.forEach(layer => { 
        layer.classList.add('slide-in-right');
        layer.classList.remove('slide-out-right');
       
      });
        //Fruta movimiento Izquierda
      layersI.forEach(layeri => {
        layeri.classList.add('slide-in-left');
        layeri.classList.remove('slide-out-left');
       
      }); 
        //Fruta movimiento top
      layersT.forEach(layert => {
        layert.classList.add('slide-in-down');
        layert.classList.remove('slide-out-up');
       
      });

       //hoja rota Izquierda
      hojasI.forEach(layeri => {
        layeri.classList.add('rotahojaizq');
        layeri.classList.remove('rotahojaizqout');
       
      }); 
      //hoja rota derecha
      hojasD.forEach(layeri => {
        layeri.classList.add('rotahojader');
        layeri.classList.remove('rotahojaderout');
        
       
      }); 
    } else if (entry.intersectionRatio < 0.49) {

      layers.forEach(layer => {
        layer.classList.remove('slide-in-right');
        layer.classList.add('slide-out-right');
       
      });
      layersI.forEach(layeri => {
        layeri.classList.remove('slide-in-left');
        layeri.classList.add('slide-out-left');
       
      });
       hojasI.forEach(layeri => {
        layeri.classList.remove('rotahojaizq');
        layeri.classList.add('rotahojaizqout');
       
      });
      hojasD.forEach(layeri => {
        layeri.classList.remove('rotahojader');
        layeri.classList.add('rotahojaderout');
       
      });
        
      layersT.forEach(layert => {
        layert.classList.remove('slide-in-down');
        layert.classList.add('slide-out-up');
       
      });
    }
  });
};

// Opciones de configuración del Intersection Observer
const options = {
  root: null, // El área de visualización es el viewport
  rootMargin: "0px", // Sin margen adicional
  threshold: [0.3, 0.5], // Se considera intersectado cuando al menos el 30% o 50% del elemento es visible
};

// Crea una instancia de Intersection Observer para la sección 1
const section1 = document.querySelector('.sect1');
const observer1 = new IntersectionObserver(callback, options);
observer1.observe(section1);

// Crea una instancia de Intersection Observer para la sección 2
const section2 = document.querySelector('.sect2');
const observer2 = new IntersectionObserver(callback, options);
observer2.observe(section2);

// Crea una instancia de Intersection Observer para la sección 3
const section3 = document.querySelector('.sect3');
const observer3 = new IntersectionObserver(callback, options);
observer3.observe(section3);

// Crea una instancia de Intersection Observer para la sección 4
const section4 = document.querySelector('.sect4');
const observer4 = new IntersectionObserver(callback, options);
observer4.observe(section4);

// Crea una instancia de Intersection Observer para la sección 5
const section5 = document.querySelector('.sect5');
const observer5 = new IntersectionObserver(callback, options);
observer5.observe(section5);

// Crea una instancia de Intersection Observer para la sección 6
const section6 = document.querySelector('.sect6');
const observer6 = new IntersectionObserver(callback, options);
observer6.observe(section6);

// Crea una instancia de Intersection Observer para la sección 7
const section7 = document.querySelector('.sect7');
const observer7 = new IntersectionObserver(callback, options);
observer7.observe(section7);

// Crea una instancia de Intersection Observer para la sección 8
const section8 = document.querySelector('.sect8');
const observer8 = new IntersectionObserver(callback, options);
observer8.observe(section8);




// irene
